import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { AuthService } from '../../../core/auth.service';
import { HELP_CLINIC_PROFILE } from '../../../shared/constants/help-buttons';
import { PopoverService } from '../../../shared/popover/popover.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'group-selection-modal-component',
    templateUrl: './group-selection-modal.component.html',
    styleUrls: ['./group-selection-modal.component.scss'],
})
export class GroupSelectionModalComponent implements OnChanges {
    @Input() params: Object;
    @Input() formLoading: boolean;
    @Input() fb: FormBuilder;
    @Input() form: FormGroup;
    @Input() responseMessage: string;
    @Input() errorMessage: string[];
    @Input() languages: Object[];
    @Input() itemLanguage: string;
    @Input() formSubmitted: boolean;
    @Input() selfReports: Object[];
    @Input() domains: Object[];
    @Input() parentGroups: Object[];
    @Input() groupsData: Object[];
    @Input() filteredDomains: Object[];
    @Input() filteredFeelings: Object[];
    @Input() feelings: Object[];
    @Input() authService: AuthService;
    @Input() helpRawData = '';
    @Input() token: string;

    @Output() hideModal = new EventEmitter<any>();
    @Output() submit = new EventEmitter<any>();
    @Output() openFormModal = new EventEmitter<any>();
    @Output() activateConfirmationModal = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();

    HELP_CLINIC_PROFILE = HELP_CLINIC_PROFILE;
    orderedDomains: any;
    selectedDomains: any;
    domainIds = [];
    groupSelectedIndex: number = 0;
    isAnanmestic: boolean;
    feelingsIdSelectedByGroup: any[] = [];
    feelingsSelectedByGroup: any[] = [];
    checked = false;
    acuteableFeelings: any;
    ananableFeelings: any;

    @ViewChild('formDirective') private formDirective: NgForm;

    constructor(
        public popoverService: PopoverService,
        public translate: TranslateService,
    ) {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['groupsData']) {
            this.initData();
        }
        if (changes['params'] && this.formDirective) {
            this.formDirective.resetForm();
        }
        // set helpTemplates
        this.popoverService.setHelpContent(this.helpRawData);
    }

    initData() {
        this.feelingsSelectedByGroup = [];
        this.feelingsIdSelectedByGroup = [];
        this.domainIds = [];
        this.filteredFeelings = this.feelings;
        if(this.groupsData.length < 1){
            this.feelingsSelectedByGroup[0] = [];
            this.feelingsIdSelectedByGroup[0] = [];
        }
        else{
            for (let index in this.groupsData) {
                this.feelingsSelectedByGroup.push(this.groupsData[index]['feelings']);
                this.feelingsIdSelectedByGroup.push(_.map(this.groupsData[index]['feelings'], 'id'));
            }
        }
    }

    //Getting form array
    get getGroups() {
        let groups = this.form.get('groups') as FormArray;
        return groups;
    }


    // Adding Dinind
    addNewGroupData() {
        let nameControls: Record<string, any> = {};
        this.languages.forEach(function(lang){
            nameControls['name_' + lang['locale']] = new FormControl({value: null, disabled: false}, [Validators.required])
        });
        this.getGroups.push(
            this.fb.group({
                id: new FormControl({value: null, disabled: false}, []),
                name_en_GB: new FormControl({value: null, disabled: false}, [Validators.required, <any>Validators.minLength(3)]),
                name_de_CH: new FormControl({value: null, disabled: false}, [Validators.required, <any>Validators.minLength(3)]),
                name_fr_FR: new FormControl({value: null, disabled: false}, [Validators.required, <any>Validators.minLength(3)]),
                name_it_IT: new FormControl({value: null, disabled: false}, [Validators.required, <any>Validators.minLength(3)]),
                feelings: new FormControl({value: null, disabled: false}, [Validators.required])
            })
        );

        this.feelingsSelectedByGroup.push([]);
    }

    deleteNewGroupData(i) {
        this.getGroups.removeAt(i);
        this.feelingsSelectedByGroup.splice(i, 1);
        this.feelingsIdSelectedByGroup.splice(i, 1);
    }

    feelingById(feeling, feelingInGroup) {
        return _.find(feelingInGroup, {id: feeling['id']});
    }

    feelingIDsByGroup(groupData) {
        return _.map(groupData.controls['feelings'].value, 'id');
    }

    removeFeeling(feeling, index) {
        let feelingsIdSelectedByGroup = _.cloneDeep(this.feelingsIdSelectedByGroup[index]);
        let feelingsSelectedByGroup = _.cloneDeep(this.feelingsSelectedByGroup[index]);
        _.remove(feelingsSelectedByGroup, function (item) {
            return item.id == feeling['id'];
        });
        _.remove(feelingsIdSelectedByGroup, function (item) {
            return item == feeling['id'];
        });
        this.feelingsSelectedByGroup[index] = feelingsSelectedByGroup;
        this.feelingsIdSelectedByGroup[index] = feelingsIdSelectedByGroup;
    }

    collectFeelings(item) {
        if(!this.domainIds || !this.domainIds.length){
            this.filteredFeelings = this.feelings;
            return;
        }
        this.filteredFeelings = _.filter(this.feelings, function (feeling) {
            return item.value.indexOf(feeling?.domain_id) > -1;
        });
    }

    toggleFeeling(feeling, groupIndex) {
        const feelingId = feeling.id;
        if (this.feelingsIdSelectedByGroup[groupIndex].indexOf(feelingId) > -1) {
            let selectedFeeling = _.cloneDeep(feeling);
            if (this.feelingsSelectedByGroup.length) {
                this.feelingsSelectedByGroup[groupIndex].push(selectedFeeling);
                return;
            }
            this.feelingsSelectedByGroup.push([selectedFeeling]);
            return;
        }
        return this.removeFeeling(feeling, groupIndex);
    }

    getSelectedFeelings() {
        const feelingIds = this.form.controls.items.value;
        let selectedFeelings = _.filter(this.feelings, function (feeling) {
            return feelingIds.indexOf(feeling.id) > -1;
        });
        return selectedFeelings;
    }

    submitData() {
        for (let index in this.feelingsSelectedByGroup) {
            let group = this.form.controls['groups']['controls'][index];
            group.controls['feelings'].setValue(this.feelingsSelectedByGroup[index]);
        }
        return this.submit.emit();
    }

    toggleMatSelect($event){
        this.form.controls['searchTxt'].setValue('');
    }

    hide() {
        return this.hideModal.emit();
    }
}
